import React from 'react';
import { connect } from 'react-redux';
import './TimeEntryInfo.css';
import TimeEntryInfoContent from './TimeEntryInfoContent/TimeEntryInfoContent';
import { TIMELINE } from '../../../../../../content';

const TimeEntryInfo = props => {
  const { hoveredSpot, subSection, subPage, sceneVideo, height } = props;
  const spotActive =
    hoveredSpot !== -1 &&
    subSection.length === 0 &&
    subPage.length === 0 &&
    sceneVideo.length === 0;
  const spotData = spotActive ? TIMELINE[hoveredSpot] : {};

  return (
    <div
      id="time-entry-info"
      className={`${spotActive ? 'active' : ''} ${height < 640 ? 'small' : ''}`}
    >
      <TimeEntryInfoContent
        active={spotActive}
        data={spotData}
        spotId={hoveredSpot}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  height: state.ui.height,
  hoveredSpot: state.app.hoveredSpot,
  subSection: state.app.subSection,
  subPage: state.app.subPage,
  sceneVideo: state.app.sceneVideo,
});

export default connect(mapStateToProps)(TimeEntryInfo);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneUI/TimeEntryInfo/TimeEntryInfo.js